import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "data-follow-fill": "currentColor",
  d: "M8 17h-.8.8Zm-.488-1.38-.45.662.45-.662Zm8.976 0 .45.662-.45-.662ZM12 1v.8A7.2 7.2 0 0 1 19.2 9h1.6A8.8 8.8 0 0 0 12 .2V1Zm8 8h-.8a7.188 7.188 0 0 1-3.161 5.958l.45.662.449.662A8.788 8.788 0 0 0 20.8 9H20Zm-4 7.503h-.8V17h1.6v-.497H16ZM16 17h-.8a1.2 1.2 0 0 1-1.2 1.2v1.6a2.8 2.8 0 0 0 2.8-2.8H16Zm-2 2v-.8h-4v1.6h4V19Zm-4 0v-.8A1.2 1.2 0 0 1 8.8 17H7.2a2.8 2.8 0 0 0 2.8 2.8V19Zm-2-2h.8v-.497H7.2V17H8Zm-.488-1.38.45-.662A7.188 7.188 0 0 1 4.8 9H3.2c0 3.03 1.534 5.7 3.862 7.282l.45-.662ZM4 9h.8A7.2 7.2 0 0 1 12 1.8V.2A8.8 8.8 0 0 0 3.2 9H4Zm4 7.503h.8a1.88 1.88 0 0 0-.839-1.545l-.45.662-.449.662c.103.07.138.16.138.221H8Zm8.488-.883-.45-.662a1.878 1.878 0 0 0-.838 1.545h1.6c0-.06.035-.151.138-.221l-.45-.662Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "data-follow-stroke": "currentColor",
  d: "M9 22h6M8.639 10.5l1.642-3.284a.4.4 0 0 1 .715 0L12.64 10.5m2.542-3.7v3.4",
  stroke: "currentColor",
  "stroke-width": "1.6",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }